// Chiamata da Choices se devo inserire le credenziali in Auth0

import React from "react";
import useStyleLogin from "../../styles/adminStyles/useStyleLogin";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import SendIcon from "@material-ui/icons/Send";

import { useAuth0 } from "@auth0/auth0-react";

const Login = () => {
  const classes = useStyleLogin();
  const { loginWithRedirect } = useAuth0();
  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography className={classes.title} gutterBottom>
          Loggati per inserire nuove ricerche
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          onClick={() => loginWithRedirect()}
          className={classes.actionsButton}
          variant="contained"
          endIcon={<SendIcon />}
        >
          LogIn
        </Button>
      </CardActions>
    </Card>
  );
};

export default Login;
